import * as React from 'react';
import classNames from 'classnames';

type JustifyContent =
  | 'center'
  | 'flex-end'
  | 'flex-start'
  | 'space-around'
  | 'space-between'
  | 'space-evenly';
type AlignItems = 'baseline' | 'center' | 'flex-end' | 'flex-start' | 'stretch';

export interface RowProps {
  id?: string;
  justifyContent?: JustifyContent;
  alignItems?: AlignItems;
  children?: React.ReactNode;
  className?: string;
}

const Row: React.FunctionComponent<React.HTMLAttributes<HTMLDivElement> &
  RowProps> = (props: RowProps) => {
  const { id, justifyContent, alignItems, children, className } = props;

  const rowClass = classNames(className, 'ui-grid-row', {
    [`ui-grid-row--justifyContent-${justifyContent}`]: justifyContent,
    [`ui-grid-row--alignItems-${alignItems}`]: alignItems,
  });

  return (
    <div id={id} className={rowClass}>
      {children}
    </div>
  );
};

export default Row;
